<template>
  <div class="people">
    {{ $t('hearttoheart2') }}
    <br />
    {{ $t('withPeople2') }}
    <br />
    {{ $t('showyourtalent2') }}
  </div>
</template>

<script>
export default {
  name: 'GoliveTitle',
  props: [],
  data() {
    return {
      GoliveTitle: null
    }
  }
}
</script>
